export interface ApiConfig {
    API_URL: string;
}

const win: ApiConfig = {
    // API_URL: 'http://localhost:5223/',
    API_URL: 'https://wfapi.ddmg-ltd.com/api/',
};

const mac: ApiConfig = {
    API_URL: 'https://wfapi.ddmg-ltd.com/api/',
};

const production: ApiConfig = {
    API_URL: 'https://wfapi.ddmg-ltd.com/api/',
};

const stage: ApiConfig = {
    API_URL: 'https://wfapi.ddmg-ltd.com/',
}
const environments = {
    win,
    mac,
    production,
    stage
}

//@ts-ignore
export const apiConfig: ApiConfig = environments[process.env.REACT_APP_STAGE];
// export const apiConfig: ApiConfig = environments.stage;
